module.exports = __webpack_public_path__ + "img/orange_068.4dbed73e.png";